
import axios from '../../http/axios/index.js'

export default {
  SET_BEARER (state, accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
  },
  SAVE_PROFILE_ACCESS(state, payload){
    state.profileAccess = payload
  },
  REMOVE_PROFILE_ACCCESS(state) {
  	state.profileAccess = []
  }
}
